<template>
  <ul class="pagination" :class="paginationClass">
    <li class="page-item prev-page" :class="{disabled: value === 1}">
      <a class="page-link" aria-label="Previous" @click="prevPage">
        <i class="fa fa-angle-double-left" aria-hidden="true"></i>
      </a>
    </li>
    <li class="page-item" :class="{active: value === item}" v-for="item in range(minPage, maxPage)">
      <a class="page-link" @click="changePage(item)">{{item}}</a>
    </li>
    <li class="page-pre next-page" :class="{disabled: value === totalPages}">
      <a class="page-link" aria-label="Next" @click="nextPage">
        <i class="fa fa-angle-double-right" aria-hidden="true"></i>
      </a>
    </li>
  </ul>
</template>
<script>
  import { mapGetters } from 'vuex'
  import {TIPO_REQUEST} from '../../store/actions/componentType'

  export default{
    name: 'p-pagination',
    props: {
      type: {
        type: String,
        default: 'default'
      },
      searchQuery: {
        type: String,
        default: 'default'
      },
      order: {
        type: String,
        default: 'default'
      },
      pageCount: {
        type: Number,
        default: 0
      },
      perPage: {
        type: Number,
        default: 10
      },
      total: {
        type: Number,
        default: 0
      },
      value: {
        type: Number,
        default: 1
      }
    },
    computed: {
      ...mapGetters({
        tableData: 'tableData'
      }),
      paginationClass () {
        return `pagination-${this.type}`
      },
      totalPages () {
        if (this.pageCount > 0) return this.pageCount
        if (this.total > 0) {
          return Math.ceil(this.total / this.perPage)
        }
        return 1
      },
      pagesToDisplay () {
        if (this.totalPages > 0 && this.totalPages < this.defaultPagesToDisplay) {
          return this.totalPages
        }
        return this.defaultPagesToDisplay
      },
      minPage () {
        if (this.value >= this.pagesToDisplay) {
          const pagesToAdd = Math.floor(this.pagesToDisplay / 2)
          const newMaxPage = pagesToAdd + this.value
          if (newMaxPage > this.totalPages) {
            return this.totalPages - this.pagesToDisplay + 1
          }
          return this.value - pagesToAdd
        } else {
          return 1
        }
      },
      maxPage () {
        if (this.value >= this.pagesToDisplay) {
          const pagesToAdd = Math.floor(this.pagesToDisplay / 2)
          const newMaxPage = pagesToAdd + this.value
          if (newMaxPage < this.totalPages) {
            return newMaxPage
          } else {
            return this.totalPages
          }
        } else {
          return this.pagesToDisplay
        }
      }
    },
    data () {
      return {
        defaultPagesToDisplay: 5
      }
    },
    methods: {
      range (min, max) {
        let arr = []
        for (let i = min; i <= max; i++) {
          arr.push(i)
        }
        return arr
      },
      changePage (item, searchQuery) {
        // mudando de pagina
        this.$emit('input', item)
        let page = item
        let limit = this.perPage
        let search = this.searchQuery
        let order = this.order
        // verifica qndo tem pesquisa passar descricao da pesquisa
        // #this.searchQuery
        this.$store.dispatch(TIPO_REQUEST, { page, limit, search, order })
      },
      nextPage () {
        // proxima página
        if (this.value < this.totalPages) {
          this.$emit('input', this.value + 1)
        }
        let page = this.value + 1
        let limit = this.perPage
        let search = ''
        let order = this.order
        this.$store.dispatch(TIPO_REQUEST, { page, limit, search, order })
      },
      prevPage () {
        // voltar pagina
        if (this.value > 1) {
          this.$emit('input', this.value - 1)
        }
        let page = this.value - 1
        let limit = this.perPage
        let search = ''
        let order = this.order
        this.$store.dispatch(TIPO_REQUEST, { page, limit, search, order })
      }
    },
    watch: {
      perPage (value) {
        let page = 1
        let limit = this.perPage
        let search = ''
        let order = this.order
        this.$store.dispatch(TIPO_REQUEST, { page, limit, search, order })
        this.$emit('input', 1)
      },
      total (value) {
        this.$emit('input', 1)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Pagination.vue